import { collection, query, orderBy, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchUserBookmarks(uid) {
  const bookmarksRef = collection(db, 'artifacts', appId, 'users', uid, 'bookmarks');
  const q = query(bookmarksRef, orderBy('savedAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));
}

export async function deleteUserBookmark(qId, uid) {
  const ref = doc(db, 'artifacts', appId, 'users', uid, 'bookmarks', qId);
  await deleteDoc(ref);
}
